var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgsLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-7 {\n        fill: #fefefe;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 371.03,
    y1: 183.38,
    x2: 419.28,
    y2: 304.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff8e0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff9f05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa603"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 521.01,
    y1: 229.28,
    x2: 640.24,
    y2: 372.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2762c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2876d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2a94e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2ca9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2db6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ebbf9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 307.2,
    y1: 443.87,
    x2: 633.97,
    y2: 374.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f01aa8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#e31ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#d31ac1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ce1ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d215c0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 357.36,
    y1: 433.01,
    x2: 739.39,
    y2: 469.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#431d99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#401c93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#391984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2e166b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b1563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 594.27,
    y1: 463,
    x2: 709.88,
    y2: 504.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008cce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126cb4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M538.61,173.67l-45.55,77.22-51.45,87.21c-82.45,26.25-135.86,87.1-141.86,96.49L497.11,104l41.5,69.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M690.12,427.99c-2.79-3.28-5.69-6.36-8.68-9.25,0,0,0-.01-.01-.02-.65-1.33-40.46-81.64-142.82-91.63l-45.55-76.2,45.55-77.22,151.51,254.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M681.43,418.72c-56.16-54.53-143.3-44.25-143.3-44.25-140.59,12.94-181.7,137.53-181.7,137.53h-102.89l46.02-77.1c.06-.1.12-.2.19-.31,6-9.39,59.41-70.24,141.86-96.49,21.66-6.9,45.32-11.41,70.65-11.97,9.21-.2,17.99.14,26.35.96,102.36,9.99,142.17,90.3,142.82,91.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M740.17,512h-9.7c-58.89-59.57-142.21-84-142.21-84-110.55-27.57-172.85,25.53-189.19,39.83-16.34,14.3-42.64,44.17-42.64,44.17,0,0,41.11-124.59,181.7-137.53,0,0,87.14-10.28,143.3,44.25.01.01.01.02.01.02,2.99,2.89,5.89,5.97,8.68,9.25h.01s50.04,84.01,50.04,84.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M730.47,512h-92.08l-50.13-84s83.32,24.43,142.21,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M538.61,327.09c-8.36-.82-17.14-1.16-26.35-.96-25.33.56-48.99,5.07-70.65,11.97l51.45-87.21,45.55,76.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1481437414736",
    "data-name": 1481437414736
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.2,759l84.15-189.39h43.33l84.98,189.39h-46.01l-69.59-167.27h17.57l-69.59,167.27c.17,0-44.83,0-44.83,0ZM152.7,718.44l11.04-33.35h97.87l11.38,33.35h-120.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M342.4,759v-189.39h81.97c16.9,0,31.62,2.68,43.83,8.21s21.75,13.41,28.44,23.63c6.69,10.22,10.04,22.46,10.04,36.54s-3.35,26.48-10.04,36.71c-6.69,10.22-16.23,18.1-28.44,23.63-12.21,5.53-26.93,8.38-43.83,8.38h-57.88l20.07-19.78v72.07h-44.16ZM386.57,691.96l-20.07-20.78h55.54c13.38,0,23.42-2.85,30.28-8.72,6.86-5.7,10.2-13.91,10.2-24.3s-3.35-18.6-10.2-24.3c-6.86-5.7-16.9-8.55-30.28-8.55h-55.54l20.07-20.78v107.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M537.8,759v-189.39h143.2v35.2h-99.54v119.17h103.05v35.2l-146.71-.17h0ZM578.12,680.06v-34.36h91.17v34.36h-91.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "696.39 759 777.53 646.71 777.53 678.72 699.91 569.61 749.42 569.61 803.29 645.37 782.05 645.87 835.75 569.61 883.09 569.61 805.63 676.71 805.63 645.37 887.61 759 837.08 759 781.21 678.72 801.28 678.72 746.41 759 696.39 759"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M167.92,854.54v-47.43h19.57c6.36,0,11.38,1.51,14.89,4.53,3.68,3.02,5.35,7.21,5.35,12.4,0,3.52-.84,6.54-2.51,8.88-1.67,2.51-4.01,4.36-7.03,5.7s-6.69,2.01-10.87,2.01h-14.72l3.85-3.85v17.77h-8.53ZM176.79,837.78l-3.85-4.36h14.22c3.85,0,6.86-.84,8.87-2.51s3.01-4.02,3.01-7.04-1-5.36-3.01-6.87c-2.01-1.68-4.85-2.51-8.87-2.51h-14.22l3.85-4.36v27.65h0ZM199.2,854.54l-12.04-17.26h9.54l12.04,17.26h-9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M211.08,854.54l21.41-47.43h8.7l21.58,47.43h-9.37l-18.4-42.74h3.51l-18.4,42.74h-9.03ZM220.95,843.64l2.51-6.87h25.76l2.34,6.87h-30.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M268.8,854.54v-47.43h19.57c4.18,0,7.86.67,10.87,2.01,3.01,1.34,5.35,3.18,7.03,5.87,1.67,2.51,2.51,5.53,2.51,9.05s-.84,6.54-2.51,9.05c-1.67,2.51-4.01,4.53-7.03,5.87-3.01,1.34-6.69,2.01-10.87,2.01h-14.72l3.85-4.02v17.77l-8.7-.17h0ZM277.66,837.78l-3.85-4.36h14.22c3.85,0,6.86-.84,8.87-2.51,2.01-1.68,3.01-4.02,3.01-6.87,0-3.02-1-5.36-3.01-6.87-2.01-1.68-4.85-2.51-8.87-2.51h-14.22l3.85-4.36v27.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M317.64,854.54v-47.43h8.87v47.43h-8.87ZM325.84,834.26v-7.54h26.1v7.54h-26.1ZM351.1,854.54v-47.43h8.87v47.43h-8.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "372.85 854.54 372.85 807.11 381.72 807.11 381.72 854.54 372.85 854.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M416.68,855.21c-3.68,0-7.03-.67-10.2-1.84-3.01-1.17-5.86-2.85-8.03-5.2-2.34-2.18-4.01-4.86-5.35-7.71-1.34-3.02-1.84-6.2-1.84-9.72s.67-6.87,1.84-9.72c1.34-3.02,3.01-5.53,5.35-7.71,2.34-2.18,5.02-3.85,8.03-5.2,3.01-1.17,6.52-1.84,10.2-1.84s7.53.67,10.71,2.01c3.18,1.34,6.02,3.35,8.2,5.87l-5.69,5.36c-1.84-1.84-3.68-3.18-5.86-4.19s-4.35-1.34-6.86-1.34-4.85.34-6.86,1.17c-2.01.84-3.85,2.01-5.35,3.52s-2.68,3.18-3.51,5.36c-.84,2.01-1.34,4.36-1.34,6.7s.5,4.69,1.34,6.7,2.01,3.85,3.51,5.36c1.51,1.51,3.35,2.68,5.35,3.52,2.01.84,4.35,1.17,6.86,1.17s4.68-.5,6.86-1.34c2.17-1.01,4.01-2.35,5.86-4.19l5.69,5.36c-2.17,2.68-5.02,4.53-8.2,6.03-3.18,1.17-6.69,1.84-10.71,1.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M152.19,852.69c-3.51,1.17-10.2,3.02-17.73,3.02-9.2,0-16.23-2.35-21.25-7.04-4.35-4.19-6.86-10.22-6.86-17.26,0-14.41,11.21-25.14,29.44-25.14,6.86,0,12.21,1.34,14.72,2.51l-2.17,7.37c-3.01-1.34-6.86-2.35-12.88-2.35-11.71,0-19.41,6.7-19.41,17.1s7.36,17.43,19.07,17.43c3.85,0,6.69-.5,8.03-1.17v-11.56h-9.7v-7.21h18.74v24.3h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M495.14,854.71c-3.85,0-7.36-.5-10.71-1.51-3.35-1.01-6.19-2.35-8.2-4.02l3.18-6.54c2.01,1.51,4.35,2.68,7.19,3.52,2.84,1.01,5.69,1.51,8.7,1.51,2.51,0,4.52-.34,6.19-.84,1.51-.5,2.68-1.17,3.51-2.18.67-.84,1.17-1.84,1.17-3.02,0-1.34-.5-2.51-1.67-3.35s-2.34-1.51-4.18-2.01c-1.67-.5-3.51-1.01-5.52-1.34-2.01-.34-4.01-1.01-6.19-1.51-2.01-.67-3.85-1.34-5.69-2.35-1.67-1.01-3.01-2.18-4.18-3.69-1-1.51-1.51-3.52-1.51-6.03s.67-4.69,2.17-6.87c1.34-2.01,3.51-3.69,6.36-5.03s6.52-1.84,10.87-1.84c2.84,0,5.69.34,8.7,1.01,2.84.67,5.35,1.68,7.53,3.02l-2.84,6.54c-2.17-1.17-4.35-2.18-6.69-2.68-2.34-.67-4.52-.84-6.69-.84-2.51,0-4.52.34-6.02.84-1.51.5-2.68,1.34-3.35,2.18-.67,1.01-1,2.01-1,3.02,0,1.34.5,2.51,1.51,3.35,1,.84,2.34,1.51,4.01,2.01,1.67.5,3.51,1.01,5.69,1.34,2.01.5,4.18,1.01,6.19,1.51,2.01.67,3.85,1.34,5.52,2.35,1.67,1.01,3.01,2.18,4.18,3.69,1,1.51,1.51,3.52,1.51,5.87s-.67,4.69-2.17,6.7c-1.51,2.01-3.51,3.69-6.52,5.03-3.01,1.51-6.69,2.18-11.04,2.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M546.16,854.71c-3.68,0-7.19-.67-10.37-1.84-3.18-1.17-6.02-2.85-8.36-5.03-2.34-2.18-4.18-4.69-5.52-7.54-1.34-2.85-2.01-6.03-2.01-9.22,0-3.35.67-6.54,2.01-9.39s3.18-5.36,5.52-7.37c2.34-2.18,5.02-3.69,8.2-4.86,3.18-1.17,6.69-1.84,10.37-1.84s7.19.5,10.37,1.68c3.18,1.17,5.86,2.85,8.2,4.86,2.34,2.18,4.18,4.53,5.35,7.54,1.34,2.85,2.01,6.03,2.01,9.39s-.67,6.54-2.01,9.39c-1.34,2.85-3.01,5.36-5.35,7.54-2.34,2.18-5.02,3.85-8.2,4.86-3.01,1.17-6.52,1.84-10.2,1.84h0ZM546.16,847.16c2.51,0,4.68-.34,6.69-1.17s3.85-1.84,5.35-3.35c1.51-1.51,2.68-3.18,3.51-5.03s1.34-4.19,1.34-6.54-.33-4.53-1.17-6.54c-.84-2.01-2.01-3.69-3.51-5.03s-3.35-2.51-5.35-3.35-4.35-1.17-6.69-1.17-4.68.34-6.86,1.17c-2.01.84-3.85,1.84-5.35,3.35-1.51,1.51-2.68,3.18-3.51,5.03-.84,2.01-1.34,4.02-1.34,6.37s.5,4.36,1.34,6.37c.84,2.01,2.01,3.69,3.51,5.2s3.35,2.51,5.35,3.35c2.01,1.01,4.18,1.34,6.69,1.34h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "581.63 854.03 581.63 808.28 590.5 808.28 590.5 846.83 615.76 846.83 615.76 854.03 581.63 854.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M642.86,854.71c-6.52,0-11.71-1.84-15.56-5.36-3.68-3.52-5.69-8.72-5.69-15.42v-25.64h9.03v25.48c0,4.69,1,8.05,3.18,10.22,2.17,2.18,5.19,3.18,9.03,3.18s6.86-1.01,9.03-3.18,3.18-5.53,3.18-10.22v-25.48h8.87v25.64c0,6.7-1.84,11.73-5.69,15.42-3.51,3.52-8.7,5.36-15.39,5.36h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "685.52 854.03 685.52 815.49 669.46 815.49 669.46 808.28 710.44 808.28 710.44 815.49 694.55 815.49 694.55 854.03 685.52 854.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "717.3 854.03 717.3 808.28 726.17 808.28 726.17 854.03 717.3 854.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M761.8,854.71c-3.68,0-7.19-.67-10.37-1.84s-6.02-2.85-8.36-5.03c-2.34-2.18-4.18-4.69-5.52-7.54s-2.01-6.03-2.01-9.22c0-3.35.67-6.54,2.01-9.39,1.34-2.85,3.18-5.36,5.52-7.37,2.34-2.18,5.02-3.69,8.2-4.86,3.18-1.17,6.69-1.84,10.37-1.84s7.19.5,10.37,1.68c3.18,1.17,5.86,2.85,8.2,4.86,2.34,2.18,4.18,4.53,5.35,7.54,1.34,2.85,2.01,6.03,2.01,9.39s-.67,6.54-2.01,9.39c-1.34,2.85-3.01,5.36-5.35,7.54-2.34,2.18-5.02,3.85-8.2,4.86-3.01,1.17-6.36,1.84-10.2,1.84h0ZM761.8,847.16c2.51,0,4.68-.34,6.69-1.17s3.85-1.84,5.35-3.35c1.51-1.51,2.68-3.18,3.51-5.03.84-2.01,1.34-4.19,1.34-6.54s-.33-4.53-1.17-6.54c-.84-2.01-2.01-3.69-3.51-5.03-1.51-1.34-3.35-2.51-5.35-3.35s-4.35-1.17-6.69-1.17-4.68.34-6.86,1.17c-2.01.84-3.85,1.84-5.35,3.35-1.51,1.51-2.68,3.18-3.51,5.03-.84,2.01-1.34,4.02-1.34,6.37s.5,4.36,1.34,6.37c.84,2.01,2.01,3.69,3.51,5.2s3.35,2.51,5.35,3.35c2.01,1.01,4.35,1.34,6.69,1.34h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "797.27 854.03 797.27 808.28 804.63 808.28 834.91 843.48 831.23 843.48 831.23 808.28 840.1 808.28 840.1 854.03 832.73 854.03 802.45 818.67 806.14 818.67 806.14 854.03 797.27 854.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M868.03,854.71c-3.85,0-7.36-.5-10.71-1.51-3.35-1.01-6.19-2.35-8.2-4.02l3.18-6.54c2.01,1.51,4.35,2.68,7.19,3.52,2.84,1.01,5.69,1.51,8.7,1.51,2.51,0,4.52-.34,6.19-.84,1.51-.5,2.68-1.17,3.51-2.18.67-.84,1.17-1.84,1.17-3.02,0-1.34-.5-2.51-1.67-3.35s-2.51-1.51-4.18-2.01c-1.67-.5-3.51-1.01-5.52-1.34-2.01-.34-4.01-1.01-6.19-1.51-2.01-.67-3.85-1.34-5.69-2.35-1.67-1.01-3.01-2.18-4.18-3.69-1-1.51-1.51-3.52-1.51-6.03s.67-4.69,2.17-6.87c1.34-2.01,3.51-3.69,6.36-5.03s6.52-1.84,10.87-1.84c2.84,0,5.69.34,8.7,1.01,2.84.67,5.35,1.68,7.53,3.02l-2.84,6.54c-2.17-1.17-4.35-2.18-6.69-2.68-2.34-.67-4.52-.84-6.69-.84-2.51,0-4.52.34-6.02.84s-2.68,1.34-3.35,2.18c-.67,1.01-1,2.01-1,3.02,0,1.34.5,2.51,1.51,3.35s2.34,1.51,4.01,2.01c1.67.5,3.51,1.01,5.69,1.34,2.01.5,4.18,1.01,6.19,1.51,2.01.67,3.85,1.34,5.52,2.35,1.67,1.01,3.01,2.18,4.18,3.69,1,1.51,1.51,3.52,1.51,5.87s-.67,4.69-2.17,6.7-3.51,3.69-6.52,5.03c-3.01,1.34-6.52,2.18-11.04,2.18h0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgsLogoLight);
export default __webpack_public_path__ + "static/media/ags-logo-light.7ca398762746fa1c58ac7fb97f3855cb.svg";
export { ForwardRef as ReactComponent };